/**
 * Matching enum for the `end_user.status` column in the database.
 */
export enum HubStatus {
  NONE = "none",
  FLAGGED = "flagged",
}

export type HubStatusType = `${HubStatus}`;

/**
 * Matching enum for query params in the Hub page.
 */
export enum HubTab {
  ALL = "all",
  FLAGGED = "flagged",
  TRANSFERRED = "transferred",
  TRANSFERRED_INTERNAL = "transferred_internal",
  RESOLVED = "resolved",
  POTENTIAL_CALLBACK = "potential_callback",
}

export const HUB_TABS = [
  HubTab.ALL,
  HubTab.FLAGGED,
  HubTab.TRANSFERRED,
  HubTab.TRANSFERRED_INTERNAL,
  HubTab.RESOLVED,
  HubTab.POTENTIAL_CALLBACK,
] as const;

export type HubTabType = `${HubTab}`;
